import { render, staticRenderFns } from "./MenuAddDocument.vue?vue&type=template&id=1a085ab0&"
import script from "./MenuAddDocument.vue?vue&type=script&lang=ts&"
export * from "./MenuAddDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports